import React from 'react';
import { ServicePageTemplate } from '../components/blocks/ServicePageTemplate';
import { getService } from '../data/services';

/**
 * PAGE: /start-your-journey/sopotje
 * WORDPRESS: `service` CPT record, rendered by single-service.php
 */
export function Sopotje() {
  return <ServicePageTemplate service={getService('sopotje')} data-id="element-612" data-mp="4nj8z4i6herl" />;
}